import Vue from 'vue'
import Router from 'vue-router'

//Reservations
// import Reservations from '../components/reservations/reservationListVue/reservationListVue.vue'
//Users
import UserList from '../components/userModule/userListModule/userListVue.vue'
import UserDetail from '../components/userModule/userDetailModule/userDetailVue.vue'
import UserProfile from '../components/userModule/userProfileComponentVue/userProfileComponentVue.vue'
import PropertyDetail from '../components/adminModule/propertyVueComponent/propertyDetailVue/propertyDetailVue.vue'
import PropertyList from '../components/adminModule/propertyVueComponent/propertyListVue/propertyListVue.vue'
import UnitList from '../components/unitModule/unitListVue/unitListVue.vue'
import UnitDetail from '../components/unitModule/unitDetailVue/unitDetailVue.vue'
import listManagement from '../components/listManagementModule/listManagementVue/listManagementVue.vue'
import tax from '../components/taxModule/taxVue/taxVue.vue'
import taxDetail from '../components/taxModule/taxDetailVue/taxDetailVue.vue'

import ledgerAccount from '../components/ledgerAccountModule/ledgerAccountVue/ledgerAccountVue.vue'

import ClientDetail from '../components/adminModule/clientVueComponent/clientDetailVue/clientDetailVue.vue'
import ClientList from '../components/adminModule/clientVueComponent/clientListVue/clientListVue.vue'

import IntegrationPage from '../components/IntegrationComponent/IntegrationComponent.vue'

import PaymentReports from '../components/PaymentReports/PaymentReports.vue'

import Dashboard from '../components/Dashboard/Dashboard.vue'
import SalesReport from '../components/Dashboard/SalesReport/SalesReport.vue'
import PaymentsReport from '../components/Dashboard/PaymentsReport/PaymentsReport.vue'

import RoleList from '../components/roles/roleList/roleList.vue'
import RoleDetail from '../components/roles/roleDetail/roleDetail.vue'

import ReservationDetail from "../components/reservations/reservationDetailVue/reservationDetailVue.vue"
import ReservationList from "../components/reservations/reservationListVue/reservationListVue.vue"
import TempoEmailService from "../components/emailService/tempoEmailService.vue"
import tapeChartGrid from "../components/tapeChartModule/tapeChart/tapeChart.vue";

import UserPasswordValidate from "../components/userModule/userChangePassword/userChangePasswordVue.vue"

import guestProfileList from "../components/guestProfile/guestProfileListVue/guestProfileListVue.vue"
import guestProfileDetail from "../components/guestProfile/guestProfileDetailVue/guestProfileDetailVue.vue"
import map from '../components/adminModule/map/map.vue'
import Lightbox from '../components/Lightbox/Lightbox.vue'
import timePicker from '../components/timePicker/timepicker.vue'
import homePageComponent from '../components/homeModule/homePageComponent/homePageComponent.vue'

import DateRangePicker from '../components/DateRangePicker/components/DateRangePicker.vue'


import rateOverrideModule from "../components/ratesModule/rateOverrideModule/rateOverride.vue"
import rateOverrideList from "../components/ratesModule/rateOverrideList/rateOverrideList.vue"
// import rateOverrideList from "../components/ratesModule/rateOverrideList/rateOverrideList.vue"
import listview from "../components/ratesModule/ItemsInList/itemsinlist.vue"

import restrictionList from "../components/restrictionsModule/restrictionsList/restrictionsList.vue"
import restrictionDetail from "../components/restrictionsModule/restrictionsDetail/restrictionsDetail.vue"
import houseKeepingStatus from "../components/houseKeepingStatus/houseKeepingDetail.vue"

import roomInventoryDetail from "../components/roomInventory/roomInventoryDetail/roomInventoryDetail.vue"

import tapeChart from "../components/commonComponents/reactComponent/reactGrid.vue"
import rs from "../components/reservations/RecycleScroller/RecycleScroller.vue"
//import trailComponent from "../components/trailComponent/trailComponent.vue"


import bookingEngineList from "../components/BookingEngineSetups/BookingEngine/BookingEngineList/BookingEngineList.vue"
import bookingEnginedetail from "../components/BookingEngineSetups/BookingEngine/BookingEngineDetail/BookingEngineDetail.vue"


import notificationTemplate from "../components/notificationTemplates/notificationTemplate/notificationTemplate.vue"
import templatesList from "../components/notificationTemplates/templatesList/templatesListComponent.vue"

// import MessengerBotDetail from "../components/BotModule/MessengerBotDetailVue/MessengerBotDetailVue.vue"
// import MessengerBotsList from "../components/BotModule/MessengerBotsList/MessengerBotsListVue.vue"
import BotsList from "../components/BotModule/BotsList/BotsList.vue"
import BotDetail from "../components/BotModule/BotDetail/BotDetail.vue"
// import PaymentBotDetail from "../components/BotModule/PaymentBotDetail/PaymentBotDetail.vue"

import UnitTypeList from '../components/unitType/unitTypeList/unitTypeList.vue'
import UnitTypeDetail from '../components/unitType/unitTypeDetail/unitTypeDetail.vue'
import ratePlanList  from '../components/ratePlan/ratePlanList/ratePlanList.vue'
import ratePlanDetail  from '../components/ratePlan/ratePlanDetail/ratePlanDetail.vue'


import openApiTokenDetail from '../components/openApi/openApiTokenDetail.vue'

import messageInbox from '../components/messageInboxComponent/messageInbox.vue'
import messageConvrestaionListComponent from '../components/messageInboxComponent/messageConvrestaionListComponent/messageConvrestaionListComponent.vue'

import wheelhouseIntegrationDetail from '../components/IntegrationComponent/wheelHouseIntegration/wheelhouseIntegrationDetail/wheelhouseIntegrationDetail.vue'

import finalyticIntegrationDetail from '../components/IntegrationComponent/FinalyticIntegration/FinalyticIntegrationDetails/finalyticIntegrationDetail.vue'

import guestCompanyProfileDetailComponent from '../components/guestProfile/guestProfileDetailVue/guestProfileDetailVue.vue'
import slimCdIntegrationDetail from '../components/IntegrationComponent/PaymentGatewayIntegration/SlimCdIntegrationDetails/slimCdIntegrationDetail.vue'

import OpenApi from "../components/SupportPortal/openApi/openApi.vue"
import OrchestrationEvents from "../components/SupportPortal/orchestrationEvents/orchestrationEvents.vue"
import IncomingMessages from "../components/SupportPortal/incomingMessages/incomingMessages.vue"

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/clientList',
      name: 'ClientList',
      component: ClientList
    },
    {
      path: '/newReservation/:ReservationId/:guestProfileId?/:accountType?',
      name: 'ReservationDetail',
      component: ReservationDetail,
      props: { isFromSummary: false }
    },
    {
      path: '/ReservationList',
      name: 'ReservationList',
      component: ReservationList,
      props: {}
    },
    {
      path: '/TempoEmailServiceStatus',
      name: 'TempoEmailServiceStatus',
      component: TempoEmailService,
      props: {}
    },
    {
      path: '/',
      name: 'homePage',
      component: homePageComponent,
      props: {}
    },
    {
      path: '/userprofile',
      name: 'UserProfile',
      component: UserProfile,
      props: {}
    },
    {
      path: '/users',
      name: 'Users',
      component: UserList,
      props: {}
    },
    {
      path: '/userDetail/:userId',
      name: 'UserDetail',
      component: UserDetail,
      props: {}
    },
    {
      path: '/roles',
      name: 'RoleList',
      component: RoleList,
      props: {}
    },
    {
      path: '/integrationPage',
      name: 'IntegrationPage',
      component: IntegrationPage,
      props: {}
    },
    {
      path: '/PaymentReports',
      name: 'PaymentReports',
      component: PaymentReports,
      props: {}
    },
    {
      path: '/Dashboard',
      name: 'Dashboard',
      component: Dashboard,
      props: {}
    },
    {
      path: '/SalesReport',
      name: 'SalesReport',
      component: SalesReport,
      props: {}
    },
    {
      path: '/PaymentsReport',
      name: 'PaymentsReport',
      component: PaymentsReport,
      props: {}
    },
    {
      path: '/roleDetail/:roleId',
      name: 'RoleDetail',
      component: RoleDetail,
      props: {}
    },
    {
      path: '/propertyList',
      name: 'PropertyList',
      component: PropertyList,
      props: {}
    },
    {
      path: '/propertyDetail/:propertyId',
      name: 'PropertyDetail',
      component: PropertyDetail,
      props: {}
    },
    {
      path: '/unitList',
      name: 'UnitList',
      component: UnitList,
      props: {}
    },
    {
      path: '/ratePlanList',
      name: 'ratePlanList',
      component: ratePlanList,
      props: {}
    },
    {
      path: '/ledgerAccount',
      name: 'ledgerAccount',
      component: ledgerAccount,
      props: {}
    },

    {
      path: '/listManagement',
      name: 'listManagement',
      component: listManagement,
      props: {}
    },

    {
      path: '/tax',
      name: 'tax',
      component: tax,
      props: {}
    },

    {
      path: '/taxDetail/:taxId/:propertyId/:statusId',
      name: 'taxDetail',
      component: taxDetail,
      props: {}
    },

    // {
    //   path: '/unitDetail/:propertyId',
    //   name: 'UnitDetail',
    //   component: UnitDetail,
    //   props: {}
    // },
    {
      path: '/unitDetail/:unitId/:propertyId',
      name: 'UnitDetail',
      component: UnitDetail,
    },
    {
      path: '/ratePlanDetail/:ratePlanId',
      name: 'ratePlanDetail',
      component: ratePlanDetail,
    },
    // {
    //   path: '/clientList',
    //   name: 'ClientList',
    //   component: ClientList,
    //   props: {}
    // },
    {
      path: '/clientDetail/:clientId',
      name: 'ClientDetail',
      component: ClientDetail,
      props: {}
    },
    {
      path: '/rs',
      name: 'rs',
      component: rs,
      props: {}
    },



    {
      path: '/userValidate',
      name: "UserValidate",
      component: UserPasswordValidate,
    },
    {
      path: '/guestProfileList',
      name: 'GuestProfileList',
      component: guestProfileList,
      props: {profileType : 3}
    },
    {
      path: '/companyProfileList',
      name: 'CompanyProfileList',
      component: guestProfileList,
      props: {profileType : 7}
    },
    {
      path: '/accountProfileList',
      name: 'AccountProfileList',
      component: guestProfileList,
      props: {profileType : null}
    },
    {
      path: '/guestProfileDetail/:GuestProfileId',
      name: 'GuestProfileListDetail',
      component: guestProfileDetail,
      props: {}
    },
    {
      path: '/companyProfileDetail/:GuestProfileId',
      name: 'GuestProfileListDetail',
      component: guestProfileDetail,
      props: {}
    },
    {
      path: '/map',
      name: 'googlemap',
      component: map,
      props: {}
    },
    {
      path: '/Lightbox',
      name: 'vue-easy-lightbox',
      component: Lightbox,
      props: {}
    },
    {
      path: '/DateRangePicker',
      name: 'date-range-picker',
      component: DateRangePicker,
      props: {}
    },
    {
      path: '/rateOverride/:RateId',
      name: 'RatesOverride',
      component: rateOverrideModule,
      props: {}
    },
    {
      path: '/timePicker',
      name: 'VueTimepicker',
      component: timePicker,
      props: {}
    },
    {
      path: '/rateOverrideList',
      name: 'RateOverrideList',
      component: rateOverrideList,
      props: {}
    },
    {
      path: '/listview',
      name: 'listview',
      component: listview,
      props: {}
    },
    {
      path: "/restrictionList",
      name: 'RestrictionList',
      component: restrictionList,
      props: {}
    },
    {
      path: "/restrictionDetail/:restrictionId",
      name: 'RestrictionDetail',
      component: restrictionDetail,
      props: {}
    },
    {
      path: "/houseKeepingStatus",
      name: 'HouseKeepingStatus',
      component: houseKeepingStatus,
      props: {}
    },
    {
      path: "/roomInventoryDetail",
      name: 'RoomInventoryDetail',
      component: roomInventoryDetail,
      props: {}
    },
    {
      path: "/tapechartGrid",
      name: "TapeChart",
      component: tapeChartGrid,
      props: {}
    },
    {
      path: "/calendarView",
      name: "CalendarView",
      component: tapeChart,
      props: {}
    },
    {
      path: "/bookingEngineList",
      name: "bookingEngineList",
      component: bookingEngineList,
      props: {}
    },

    {
      path: "/bookingEnginedetail/:beId",
      name: "bookingEnginedetail",
      component: bookingEnginedetail,
      props: {}
    },
    {
      path: "/notificationTemplate/:TemplateId",
      name: "notificationTemplate",
      component: notificationTemplate,
      props: {}
    },
    {
      path: "/templatesList",
      name: "templatesList",
      component: templatesList,
      props: {}
    },
    
    // {
    //   path: '/PaymentBotDetail/:PaymentId',
    //   name: 'PaymentBotDetail',
    //   component: PaymentBotDetail,
    //   props: {}
    // },
    {
      path: '/BotsList',
      name: 'BotsList',
      component: BotsList,
      props: {}
    },
    {
      path: '/BotDetail/:BotId',
      name: 'BotDetail',
      component: BotDetail,
      props: {}
    },
    

    {
      path: '/unitTypeList',
      name: 'UnitTypeList',
      component: UnitTypeList,
      props: {}
    },

    {
      path: '/unitTypeDetail/:unitTypeId/:propertyId',
      name: 'UnitTypeDetail',
      component: UnitTypeDetail,
      props: {}
    },
    // 
    // {
    //   path: "/trial",
    //   name: "trial",
    //   component: trailComponent,
    //   props: {}      
    // } 
    {
      path: '/openApiTokenDetail/:apiId',
      name: 'openApiTokenDetail',
      component: openApiTokenDetail,
      props: {}
    }, 
    {
      path: '/messageInbox/:conversationId/:reservationId',
      name: 'MessageInbox',
      component: messageInbox,
      props: {}
    },
    {
      path: '/messageConvrestaionListComponent',
      name: 'messageConvrestaionListComponent',
      component: messageConvrestaionListComponent,
      props: {}
    },
    {
      path: "/wheelhouseIntegrationDetail",
      name: "wheelhouseIntegrationDetail",
      component: wheelhouseIntegrationDetail,
      props: {}
    },
    {
      path: "/integrationDetail/:integrationId/:IntegartedClientId/:RefreshToken",
      name: "finalyticIntegrationDetail",
      component: finalyticIntegrationDetail,
      props: {}
    },
    {
      path: '/guestProfileDetail/:GuestProfileId',
      name: 'guestCompanyProfileDetail',
      component: guestCompanyProfileDetailComponent,
      props: {}
    },   
    {
      path: "/slimCdIntegrationDetail",
      name: "slimCdIntegrationDetail",
      component: slimCdIntegrationDetail,
      props: {}
    },
    {
      path: '/OpenApi',
      name: 'OpenApi',
      component: OpenApi,
      props: {}
    },
    {
      path: '/OrchestrationEvents',
      name: 'OrchestrationEvents',
      component: OrchestrationEvents,
      props: {}
    },
    {
      path: '/IncomingMessages',
      name: 'IncomingMessages',
      component: IncomingMessages,
      props: {}
    },
  ]
})
